import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledTaskTemplates = styled.div`
  padding-bottom: 20px;

  .templates-container {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .template-level {
      .ant-collapse-header-text {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          font-weight: bold;
          font-size: 110%;
        }

        .card-grades {
          display: flex;
          align-items: center;
          gap: 10px;

          .grades-list {
            display: flex;

            .ant-tag {
              border: none;
              background-color: white;
              box-shadow: ${Colors.boxShadow};
            }
          }
        }
      }
    }

    .templates {
      display: grid;
      grid-gap: 20px;
      grid-template-columns: repeat(3, 1fr);
      justify-content: space-between;
      align-items: stretch;

      @media only screen and (max-width: ${MediaQueryBreakpoints.xl}) {
        grid-template-columns: repeat(2, 1fr);
      }
      @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
        grid-template-columns: repeat(1, 1fr);
      }

      .template {
        position: relative;
        flex: 1;
        background: ${Colors.backgroundPaleBlue};
        box-shadow: 0px 1px 4px #15223228;
        border: 1px solid #e1e2ea;
        border-radius: 6px;
        padding: 0 0 30px 0;

        .template-header {
          padding: 2px 10px;
          font-size: var(--font-size-h3);
          font-weight: bold;
          border-radius: 6px 6px 0 0;
          border-bottom: 1px solid #cbcdda;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;

          .ant-tag {
            height: 22px;
          }

          .actions {
            display: flex;
            align-items: center;
            gap: 6px;
            @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
              flex-direction: column;
            }

            button {
              padding: 0px 10px;
              height: 22px;
              line-height: 20px;
              &.preview-btn {
                background: ${Colors.background};
              }
            }
          }
        }

        &.easy .template-header {
          background: ${Colors.template.easy};
        }
        &.medium .template-header {
          background: ${Colors.template.medium};
        }
        &.hard .template-header {
          background-color: ${Colors.template.hard};
          color: ${Colors.background} !important;
        }

        .template-content {
          padding: 20px 16px 10px;
          display: flex;
          flex-direction: column;
          gap: 20px;

          height: 100%;
          .activity-types {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: 4px 10px;
            justify-content: space-around;
            align-items: flex-start;

            @media only screen and (max-width: ${MediaQueryBreakpoints.lg}) {
              grid-template-columns: repeat(2, 1fr);
            }
            &::after {
              content: '';
              flex: auto;
            }

            .activity-type {
              flex: 1 0 30%;
              height: 50px;
              display: flex;
              gap: 10px;
              align-items: center;

              .activity-type-name  {
                font-size: 14px;
              }
            }
          }
          .description {
            .duration {
              display: flex;
              align-items: center;
              gap: 5px;
              .duration-icon {
                font-size: 20px;
              }
            }
            p {
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }
`;
